module.exports = __webpack_public_path__ + "delivery-motorcycle.png";